import { Component } from "react";
import { connect } from "react-redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import "../../../utils.css";
import { getCurrentFunctionName } from "../../../performanceModeManager";
import {
    Fab,
    FormControl,
    FormControlLabel,
    Hidden,
    Icon,
    InputLabel,
    MenuItem,
    Switch,
    Typography,
} from "@mui/material";
import { ALL_SELECT_OPTION } from "../../../constants";
import {
    setDisplayAsList,
    setDisplayEndedInterventions,
    setDisplayInterventionsWithoutCerfa,
    setEndDate,
    setFilteredAndSortedInterventions,
    setSelectedState,
    setSelectedType,
    setStartDate,
} from "../../../redux/intervention/extranetInterventionActions";
import { formatStatus } from "../../../redux/intervention/extranetInterventionStatus";
import { formatType } from "../../../redux/intervention/extranetInterventionTypes";
import CustomizedSelect from "../../Input/CustomizedSelect";
import DatePicker from "../../Input/DatePicker";

class InterventionsFilters extends Component {
    onTypeChange(e) {
        this.props.setSelectedType(e.target.value);
    }

    onStateChange(e) {
        this.props.setSelectedState(e.target.value);
    }

    onStartDateChange(date) {
        this.props.setStartDate(date);
    }

    onEndDateChange(date) {
        this.props.setEndDate(date);
    }

    setDisplayInterventionsWithoutCerfa() {
        this.props.setDisplayInterventionsWithoutCerfa(
            !this.props.interventions.displayInterventionsWithoutCerfa
        );
    }

    setDisplayEndedInterventions() {
        this.props.setDisplayEndedInterventions(
            !this.props.interventions.displayEndedInterventions
        );
    }

    search() {
        this.props.setFilteredAndSortedInterventions(
            { ...this.props.interventions },
            this.props.componentPark,
            this.props.affair,
            this.props.tableState,
            this.props.activeUser,
            this.props.sites.selectedSite,
            this.props.sites.sites,
            this.props.tableState.nbTotalResults
        );
    }

    setDisplayAsList() {
        this.props.setDisplayAsList(!this.props.interventions.displayAsList);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        let typeElements = this.props.interventions.types.map((t) => (
            <MenuItem key={t} value={t}>
                <Typography variant="inherit" noWrap>
                    {formatType(t)}
                </Typography>
            </MenuItem>
        ));

        typeElements.unshift(
            <MenuItem key={"none"} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        );

        let stateElements = this.props.interventions.states.map((s) => (
            <MenuItem key={s} value={s}>
                <Typography variant="inherit" noWrap>
                    {formatStatus(s)}
                </Typography>
            </MenuItem>
        ));

        stateElements.unshift(
            <MenuItem key={"none"} value={ALL_SELECT_OPTION}>
                {"Tous"}
            </MenuItem>
        );

        let searchBtnElement = (
            <Fab
                variant="extended"
                type="submit"
                color="secondary"
                onClick={this.search.bind(this)}
                className="element-right"
            >
                <Icon>search</Icon>
                Rechercher
            </Fab>
        );

        return (
            <Card className="card col-lg-12 col-md-12 col-sm-12 col-12 without-side-margin filters-card">
                <CardContent className="col-lg-12 col-md-12 col-sm-12 col-12 row without-side-padding">
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <InputLabel id="type">{"Type"}</InputLabel>
                        <CustomizedSelect
                            id="type"
                            name="type"
                            value={this.props.interventions.selectedType}
                            onChange={this.onTypeChange.bind(this)}
                        >
                            {typeElements}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <InputLabel id="state">{"Etat"}</InputLabel>
                        <CustomizedSelect
                            id="state"
                            name="state"
                            value={this.props.interventions.selectedState}
                            onChange={this.onStateChange.bind(this)}
                        >
                            {stateElements}
                        </CustomizedSelect>
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <DatePicker
                            name="start-date"
                            value={this.props.interventions.startDate}
                            onChange={this.onStartDateChange.bind(this)}
                            label="Du"
                            clearable
                            clearLabel="Effacer"
                            invalidDateMessage="La date est invalide"
                            invalidLabel="La date est invalide"
                            cancelLabel="Annuler"
                            format="DD/MM/YYYY"
                            className="full_size"
                        />
                    </FormControl>
                    <FormControl className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding">
                        <DatePicker
                            name="end-date"
                            value={this.props.interventions.endDate}
                            onChange={this.onEndDateChange.bind(this)}
                            label="Au"
                            clearable
                            clearLabel="Effacer"
                            invalidDateMessage="La date est invalide"
                            invalidLabel="La date est invalide"
                            cancelLabel="Annuler"
                            format="DD/MM/YYYY"
                            className="full_size"
                        />
                    </FormControl>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top element-right">
                        <FormControlLabel
                            className={
                                "element-right control-margin-top span-center-verticaly"
                            }
                            control={
                                <Switch
                                    value={"valide"}
                                    color="secondary"
                                    onChange={this.setDisplayInterventionsWithoutCerfa.bind(
                                        this
                                    )}
                                    checked={
                                        this.props.interventions
                                            .displayInterventionsWithoutCerfa
                                    }
                                />
                            }
                            label={
                                this.props.interventions
                                    .displayInterventionsWithoutCerfa
                                    ? "Sans cerfa inclus"
                                    : "Avec cerfa"
                            }
                        ></FormControlLabel>
                    </div>
                    <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top element-right">
                        <FormControlLabel
                            className={
                                "element-right control-margin-top span-center-verticaly"
                            }
                            control={
                                <Switch
                                    value={"valide"}
                                    color="secondary"
                                    onChange={this.setDisplayEndedInterventions.bind(
                                        this
                                    )}
                                    checked={
                                        this.props.interventions
                                            .displayEndedInterventions
                                    }
                                />
                            }
                            label={
                                this.props.interventions
                                    .displayEndedInterventions
                                    ? "Terminées inclues"
                                    : "Non terminées"
                            }
                        ></FormControlLabel>
                    </div>
                    <Hidden only={["sm", "xs"]}>
                        <div className="col-lg-3 col-md-4 col-sm-6 col-12 control-padding-right-padding without-side-margin control-margin-top row switch-label">
                            <div className="offset-xl-1 col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 right span-center-verticaly without-side-padding">
                                <span
                                    className={
                                        !this.props.interventions.displayAsList
                                            ? "green-selected-label"
                                            : ""
                                    }
                                >
                                    Cartes
                                </span>
                            </div>
                            <div className="col-xl-3 col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding div-center">
                                <Switch
                                    onChange={this.setDisplayAsList.bind(this)}
                                    checked={
                                        this.props.interventions.displayAsList
                                    }
                                    className="switch"
                                    color="default"
                                    label={"Liste"}
                                />
                            </div>
                            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 without-side-padding span-center-verticaly">
                                <span
                                    className={
                                        this.props.interventions.displayAsList
                                            ? "green-selected-label"
                                            : ""
                                    }
                                >
                                    Liste
                                </span>
                            </div>
                        </div>
                        <div className="offset-lg-0 col-lg-3 offset-md-8 col-md-4 control-margin-top">
                            {searchBtnElement}
                        </div>
                    </Hidden>
                    <Hidden only={["xl", "lg", "md"]}>
                        <div className="offset-md-8 col-md-4 offset-sm-8 col-sm-4 offset-4 col-8 control-margin-top">
                            {searchBtnElement}
                        </div>
                    </Hidden>
                </CardContent>
            </Card>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        interventions: state.extranetInterventions,
        activeUser: state.activeUser,
        tableState: state.tableState,
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedType: (value) => dispatch(setSelectedType(value)),
        setSelectedState: (value) => dispatch(setSelectedState(value)),
        setStartDate: (value) => dispatch(setStartDate(value)),
        setEndDate: (value) => dispatch(setEndDate(value)),
        setDisplayInterventionsWithoutCerfa: (value) =>
            dispatch(setDisplayInterventionsWithoutCerfa(value)),
        setDisplayEndedInterventions: (value) =>
            dispatch(setDisplayEndedInterventions(value)),
        setFilteredAndSortedInterventions: (
            interventionsFilters,
            componentPark,
            affair,
            tableState,
            user,
            customerSiteId,
            allSites,
            nbTotalResults
        ) =>
            dispatch(
                setFilteredAndSortedInterventions(
                    interventionsFilters,
                    componentPark,
                    affair,
                    tableState,
                    user,
                    customerSiteId,
                    allSites,
                    nbTotalResults
                )
            ),
        setDisplayAsList: (value) => dispatch(setDisplayAsList(value)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(InterventionsFilters);
